/**
 * FPU/FPE (Fat-Protein-Unit) calculation utilities
 */

export interface FPUResult {
  totalFPU: number;
}

/**
 * Calculate FPU/FPE based on fat and protein content
 * Uses the gram-based method:
 * - FPE_Fat = g Fat / 11
 * - FPE_Protein = g Protein / 25
 * - FPE = FPE_Fat + FPE_Protein
 */
export const calculateFPU = (fatGrams: number, proteinGrams: number): FPUResult => {
  const fatFPU = fatGrams / 11;
  const proteinFPU = proteinGrams / 25;
  const totalFPU = fatFPU + proteinFPU;

  return {
    totalFPU: Math.round(totalFPU * 100) / 100, // Round to 2 decimal places
  };
};

/**
 * Get FPU/FPE explanation text for modal
 */
export const getFPUExplanation = (language: 'en' | 'de'): string => {
  if (language === 'de') {
    return `Die Fett-Protein-Einheit (FPE) erfasst den verzögerten Blutzuckeranstieg durch Fett und Eiweiß nach Mahlzeiten.

Berechnung:
FPE = (g Fett ÷ 11) + (g Eiweiß ÷ 25)`;
  } else {
    return `The Fat-Protein-Unit (FPU) captures the delayed blood sugar rise from fat and protein after meals.

Calculation:
FPU = (g Fat ÷ 11) + (g Protein ÷ 25)`;
  }
};